// extracted by mini-css-extract-plugin
module.exports = {"PasswordResetPhone":"zh_a bhu_px bhu_a bhu_w bhu_cw bhu_sf"};